import React from "react";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { axiosget } from "../../helpers/httprequest";
import ReceiptHeader from "../../components/ReceiptHeader";
import { useQuery } from "@tanstack/react-query";
import ErrorResponse from "../../components/ErrorResponse";
import is_null from "../../helpers/is_null";

const AcceptanceLetter = () => {
  const { id } = useParams();
  const { data, isLoading, error } = useQuery({
    queryKey: ["acceptanceInformation"],
    queryFn: async () => {
      const req = await axiosget(`ms_acceptance_fee_rrr/receipt/${id}`);
      return req?.data;
    },
  });
  if (!is_null(data)) {
    setTimeout(() => window.print(), 500);
  }
  return (
    <>
      {isLoading && <Loader />}
      {error && <ErrorResponse type={`danger`} message={`Local server error: ${error}`} />}
      {data?.message !== undefined && <ErrorResponse type={`danger`} message={data?.message} />}
      {data?.message === undefined && (
        <div className="container">
          <ReceiptHeader office={<>CLEARANCE ACCEPTANCE</>} subs={<i style={{ fontSize: 15 }}>(ADMISSION MANAGEMENT COMMITTEE)</i>} />
          <br />
          <div className="letterto">
            <div className="">
              <b className="text-uppercase">KESPODAK/ADM/{data?.code}</b>
            </div>
            <div className="">Date: {new Date().toDateString()}</div>
          </div>
          <br />
          <div className="body">
            <div>The Rector</div>
            <div>Kebbi State Polytechnic</div>
            <div>Dakingari, Kebbi State</div>
            <div className="lettertitle">Admission Acceptance Letter</div>
            <div style={{ textAlign: "justify" }}>
              I,{" "}
              <b>
                <u>
                  {data?.applicant?.firstname} {data?.applicant?.middlename} {data?.applicant?.lastname}
                </u>
              </b>{" "}
              hereby accept the admission offered to me and pledge to abide by the rules and regulations of the college.
            </div>

            <div className="text-center">
              Signature & Date (Below)
              <br />
              <br />
              <br />
              ......................................................................
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AcceptanceLetter;
